import { useMutation } from '@tanstack/react-query'

import { useApi } from 'contexts/api-context'

import type { UseMutationOptions, UseMutationResult } from '@tanstack/react-query'
import type { CustomerProviderAuthConfig, ProviderType } from 'types'

export const useUpdateAuthConfig = (
  customerGuid: string,
  providerType: ProviderType,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  options?: Omit<UseMutationOptions<any, Error, CustomerProviderAuthConfig>, 'mutationFn'>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
): UseMutationResult<any, Error, CustomerProviderAuthConfig> => {
  const api = useApi()
  const url = `/customers/${customerGuid}/provider/${providerType.toString()}/auth`
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return useMutation<any, Error, CustomerProviderAuthConfig>({
    ...options,
    mutationFn: async authConfig => api.putAuthConfig(url, authConfig),
  })
}

export const useDelAuthConfig = (
  customerGuid: string,
  providerType: ProviderType
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
): UseMutationResult<any, Error, void> => {
  const api = useApi()
  const url = `/customers/${customerGuid}/provider/${providerType.toString()}`
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return useMutation<any, Error, void>({
    mutationFn: () => api.del(url),
  })
}
